import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isNil, isEmpty, get, omit } from 'lodash';
import locale from 'antd/lib/date-picker/locale/el_GR';
import myIcon from "../../assets/icons/sideMenuArrow.svg";
import { checkUser, checkUserLogged, checkUsersSession, getUser } from 'store/user/actions';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';

import { ConfigPage, ConfigPage2, GroupsConfig, LanguageConfig, SideMenu, Templates, TestSectionMenuSection, UsersConfig } from './page1/components';
import Page1 from './page1';
import { isAdminUser } from 'utils';

const AdminPage = ({ disabled }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sectionSelected, setSectionSelected] = useState(0);
  
  const [userCheck, setUserCheck] = useState(false);
  
  const userStatus = useSelector(state => state.user.status);
  const user = useSelector(state => state.user);
  const [isSideMenuVisible, setIsSideMenuVisible] = useState(true);
  // const canViewPage = isAdminUser(user?.groups);

  const toggleSideMenu = () => {setIsSideMenuVisible(!isSideMenuVisible)};

  useEffect(() => {
    dispatch(
      checkUserLogged(
        navigate,
        callback => {
          if(callback){
            dispatch(getUser());
          }
        }
      ),
    );
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
        dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (userStatus === 200 && !isEmpty(user?.groups)) {
      if (!isAdminUser(user?.groups)) navigate("/appTrack", { replace: true })
      setUserCheck(true);
    } else {
      setUserCheck(false);
    }
  }, [userStatus, user]);


  return (
    <div className="App">
      {userCheck && (
        <div className={`d-flex admin-page-body`}>
          <div onClick={toggleSideMenu} className={`toggle-menu ${isSideMenuVisible ? '' : 'toggle-menu-open'}`}>
          <img src={myIcon} alt="Toggle" />
        </div>
        <div id='admin-side-menu'>
        <SideMenu sectionSelected={sectionSelected} setSectionSelected={setSectionSelected}/>
        </div>

        <div id='admin-main-content'>
        {sectionSelected == 0 && (
            <Page1></Page1>

        )}
        {sectionSelected == 1 && (
            <ConfigPage></ConfigPage>

        )}
        {sectionSelected == 2 && (
            <Templates></Templates>

        )}
        {sectionSelected == 3 && (
            <LanguageConfig></LanguageConfig>

        )}
        {sectionSelected == 4 && (
            <UsersConfig></UsersConfig>

        )}
        {sectionSelected == 5 && (
            <GroupsConfig></GroupsConfig>

        )}
        </div>
        </div>
      )}
      {/* {!userCheck && (
        dispatch(checkUser(navigate))
      )} */}
    </div>
  );
};

export default AdminPage;